import React from "react";
import { Check, Zap } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { fieldCls } from "@/components/signup/SignupFields";
import { AMENITIES } from "@/config/business";

const Amenity = ({ k, on, onToggle, label }) => (
  <button
    type="button"
    role="checkbox"
    aria-checked={on}
    onClick={onToggle}
    data-testid={`signup-amenity-${k}`}
    className={`flex items-center gap-2.5 rounded-xl border px-3 py-2.5 text-left text-sm font-semibold transition-colors ${on ? "border-moss bg-moss/10 text-ink" : "border-line bg-parchment text-ink-muted hover:border-moss/50"}`}
  >
    <span className={`w-5 h-5 shrink-0 rounded-md border-2 grid place-items-center transition-colors ${on ? "bg-moss border-moss text-parchment" : "border-ink/30"}`}>
      {on && <Check className="w-3.5 h-3.5" strokeWidth={3} />}
    </span>
    <span className="min-w-0">{label}</span>
    {k.endsWith("_charging") && <Zap className="w-3.5 h-3.5 shrink-0 ml-auto text-amber-dark" />}
  </button>
);

export const PlaceDetails = ({ form, set, required }) => {
  const { t } = useLang();
  const s = t.pages.signup;
  const toggle = (k) => set("amenities", form.amenities.includes(k) ? form.amenities.filter((a) => a !== k) : [...form.amenities, k]);
  return (
    <div data-testid="signup-place" className="rounded-[1.5rem] border-2 border-dashed border-line p-5 md:p-7 space-y-6">
      <div>
        <h3 className="font-display text-xl font-semibold text-ink">{s.placeTitle}</h3>
        <p className="text-sm text-ink-muted mt-1">{s.placeBody}</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="signup-offer" className="font-bold text-ink">
          {s.offer}
          {required ? " *" : <span className="ml-1 font-semibold text-ink-muted">({s.optional})</span>}
        </Label>
        <Textarea id="signup-offer" rows={3} maxLength={1000} value={form.offer} onChange={(e) => set("offer", e.target.value)} placeholder={s.offerPh} data-testid="signup-offer" className={fieldCls} />
      </div>
      <fieldset>
        <legend className="font-bold text-ink mb-3">{s.amenitiesTitle}</legend>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="signup-amenities">
          {AMENITIES.map((k) => (
            <Amenity key={k} k={k} on={form.amenities.includes(k)} onToggle={() => toggle(k)} label={s.amenities[k]} />
          ))}
        </div>
      </fieldset>
    </div>
  );
};
